import { IconNameV2 } from 'common/icon/iconV2.js';
import { Tile } from 'common/tile/tile.js';
import { LinkRef } from 'components-modules/condition/link-ref.js';
import { IModule } from 'redux-state/layout/types.js';
import { ILink } from 'types/navigation.js';
import { StatusRating } from 'utilities/status/status-rating.js';
import { SummaryItem } from './item.js';

type HasLink<T extends 'Link' | undefined = undefined> = T extends ILink
  ? {
      link?: T extends 'ILink' ? ILink : null;
    }
  : Record<never, never>;

export type SummaryItemProps<T extends 'Link' | undefined = undefined> = HasLink<T> & {
  icon: IconNameV2;
  iconColor?: string;
  title?: string;
  dataModule?: string;
  subTitle?: { text: string; state?: StatusRating }[];
  content?: string[];
  html?: string[];
};

export const SummaryModule = ({ config }: IModule<SummaryItemProps<'Link'>>) => {
  return (
    <Tile dataModule="summaryItem" classes="Integrations" config={config}>
      <div className="Tile-body IconWithText--container">
        <SummaryItem dataModule="summary-item-mod" {...config} />
        <LinkRef link={config.link} />
      </div>
    </Tile>
  );
};
